import React, { Component } from 'react';
import isObject from 'lodash/isObject';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { requestGdprDeletion, requestGdprInformation } from '../actions/gdprActions';
import LandingPage from '../components/pages/GDPR/LandingPage';

class GdprContainer extends Component {

  render() {
    return (
      <LandingPage {...this.props} />
    )
  }
}

const mapStateToProps = state => {
  return {
    profile: state.profile,
    hasError: Boolean(isObject(state.common.errors) && state.common.errors['error_gdpr_deletion'])
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    requestGdprDeletion(formData) {
      dispatch(requestGdprDeletion(formData));
    },
    requestGdprInformation(formData) {
      dispatch(requestGdprInformation(formData));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GdprContainer);



// WEBPACK FOOTER //
// ./src/containers/GdprContainer.jsx